import React, { useEffect, useState } from "react";
import { Parents } from "../utils/CartegoryParent";
import { useRecoilValue } from "recoil";
import { userState } from "../Services/RecoilAtoms";
import {
  AdminViewSingleCategory,
  RemoveSingleCartegories,
  createCartegory,
} from "../utils/Api/ApiCalls";
import Swal from "sweetalert2";
import { Link } from "react-router-dom";

const ProductCategory = () => {
  const [formData, setFormData] = useState({
    name: "",
    slug: "",
    parent: "",
    desc: "",
  });

  const [allCartegory, setAllCartegory] = useState([]);
  const [searchValue, setSearchValue] = useState("");

  const currentUser = useRecoilValue(userState);
  const [load, setLoad] = useState(false);

  const OnHandleChange = (e) => {
    const { value, name } = e.target;

    setFormData((prev) => ({
      ...prev,
      [name]: value,
    }));
  };

  const UploadingCartegory = async () => {
    const { name, slug, parent, desc } = formData;
    setLoad(true);
    try {
      const response = await createCartegory(currentUser?.data?.info?.id, {
        name,
        slug: `/${name}`,
        parent,
        desc,
      });
      Swal.fire({
        icon: "success",
        title: `${response.message}`,
        timer: 2000,
        showConfirmButton: false,
      }).then(() => {
        window.location.reload();
      });
      setLoad(false);
    } catch (err) {
      return err;
    }
  };

  const ViewAllCartegory = async () => {
    try {
      const response = await AdminViewSingleCategory(
        currentUser?.data?.info?.id
      );
      setAllCartegory(response.data);
    } catch (err) {
      return err;
    }
  };

  const filteredCategories = allCartegory?.filter((props) => {
    const searchLowerCase = searchValue.toLowerCase();
    return (
      props?.slug?.toLowerCase().includes(searchLowerCase) ||
      props?.name?.toLowerCase().includes(searchLowerCase)
    );
  });

  useEffect(() => {
    ViewAllCartegory();
  }, []);

  const RemovingCartegory = async (id) => {
    const result = await Swal.fire({
      title: "Do you want to remove this category?",
      showCancelButton: true,
      confirmButtonText: "Yes, remove",
      cancelButtonText: "No, cancel",
      icon: "warning",
      showLoaderOnConfirm: true,
      preConfirm: async () => {
        try {
          const response = await RemoveSingleCartegories(
            id,
            currentUser?.data?.token
          );

          return { success: true };
        } catch (error) {
          return { success: false, message: error.message };
        }
      },
    });

    if (result.isConfirmed) {
      Swal.fire("Category removed!", "", "success");
      window.location.reload();
    } else if (result.dismiss === Swal.DismissReason.cancel) {
      Swal.fire("Category removal canceled", "", "info");
    } else if (result.value.success === false) {
      Swal.fire(
        "Error",
        `Failed to remove category: ${result.value.message}`,
        "error"
      );
    }
  };

  return (
    <section class="content-main">
      <div class="content-header">
        <div>
          <h2 class="content-title card-title">Categories</h2>
          <p>Add, edit or delete a category</p>
        </div>
        <div>
          <input
            onChange={(e) => {
              setSearchValue(e.target.value);
            }}
            type="text"
            placeholder="name, slug"
            class="form-control bg-white"
          />
        </div>
      </div>
      <div class="card">
        <div class="card-body">
          <div class="row">
            <div class="col-md-3">
              <form
                onSubmit={(e) => {
                  e.preventDefault();
                  UploadingCartegory();
                }}
              >
                <div class="mb-4">
                  <label class="form-label">
                    Name<span style={{ color: "red" }}>*</span>
                  </label>
                  <select
                    required
                    name="name"
                    onChange={OnHandleChange}
                    class="form-select"
                  >
                    <option selected disabled>
                      --Select--
                    </option>
                    <option value="Phones">Phones</option>
                    <option value="Computers">Computers</option>
                    <option value="Accessories">Accessories</option>
                    <option value="Games and Console">Games and Console</option>
                    <option value="Tablets">Tablets</option>
                    <option value="Travel Adaptors">Travel Adaptors</option>
                    <option value="Wearables">Wearables</option>
                  </select>
                </div>

                <div class="mb-4">
                  <label class="form-label">
                    Parent<span style={{ color: "red" }}>*</span>
                  </label>
                  <select
                    required
                    name="parent"
                    onChange={OnHandleChange}
                    class="form-select"
                  >
                    <option selected disabled>
                      --Select--
                    </option>
                    {Parents?.map((props) => (
                      <option value={props}>{props}</option>
                    ))}
                  </select>
                </div>
                <div class="mb-4">
                  <label class="form-label">
                    Description<span style={{ color: "red" }}>*</span>
                  </label>
                  <textarea
                    required
                    name="desc"
                    onChange={OnHandleChange}
                    placeholder="Type here"
                    class="form-control"
                  ></textarea>
                </div>
                {load ? (
                  <div class="d-grid">
                    <button disabled class="btn btn-primary">
                      Loading...
                    </button>
                  </div>
                ) : (
                  <div class="d-grid">
                    <button class="btn btn-primary">Create category</button>
                  </div>
                )}
              </form>
            </div>
            <div class="col-md-9">
              <div class="table-responsive">
                <table class="table table-hover">
                  <thead>
                    <tr>
                      <th class="text-center">
                        <div class="form-check">
                          <input
                            class="form-check-input"
                            type="checkbox"
                            value=""
                          />
                        </div>
                      </th>
                      <th>ID</th>
                      <th>Name</th>
                      <th>Slug</th>
                      <th>Description</th>
                      <th>Order</th>
                      <th class="text-end">Action</th>
                    </tr>
                  </thead>
                  <tbody>
                    {allCartegory?.length >= 1 ? (
                      <>
                        {filteredCategories?.map((props, i) => (
                          <tr>
                            <td class="text-center">
                              <div class="form-check">
                                <input
                                  class="form-check-input"
                                  type="checkbox"
                                  value=""
                                />
                              </div>
                            </td>
                            <td>{props?.id?.split("-")[0]}</td>
                            <td>
                              <b>{props?.slug?.replace("/", "")}</b>
                            </td>
                            <td>{props?.slug}</td>
                            <td>{props?.description}</td>
                            <td>{i + 1}</td>
                            <td class="text-end">
                              <div class="dropdown">
                                <a
                                  href="#"
                                  data-bs-toggle="dropdown"
                                  class="btn btn-light rounded btn-sm font-sm"
                                >
                                  <i class="material-icons md-more_horiz"></i>
                                </a>
                                <div class="dropdown-menu">
                                  {/* <a class="dropdown-item" href="#">
                                    View
                                  </a> */}
                                  <Link
                                    to={`/product-category-edit/${props?.id}`}
                                  >
                                    <a class="dropdown-item" href="#">
                                      Edit
                                    </a>
                                  </Link>
                                  <a
                                    onClick={() => {
                                      RemovingCartegory(props.id);
                                    }}
                                    class="dropdown-item text-danger"
                                    href="#"
                                  >
                                    Delete
                                  </a>
                                </div>
                              </div>
                            </td>
                          </tr>
                        ))}
                      </>
                    ) : (
                      <div>Category is empty</div>
                    )}
                  </tbody>
                </table>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default ProductCategory;

//
// <div class='mb-4'>
// <label for='product_slug' class='form-label'>
//  Slug
//  </label>
//  <input
//  type='text'
//  placeholder='Type here'
//  class='form-control'
// id='product_slug'
//  />
// </div>
